import { useShowWorkspaceSplitTopbar } from '~/components/v2/components/shared/panel/useShowWorkspaceSplitTopbar';
import { useURLBoardIdSelector } from '~/hooks/useURLBoardIdSelector';

/** True when a non-board page should show split-layout page chrome (canvas open, panel expanded). */
export const useWorkspaceSplitPageTopbar = () => {
  const showWorkspaceSplitTopbar = useShowWorkspaceSplitTopbar();
  const boardId = useURLBoardIdSelector();

  return showWorkspaceSplitTopbar && !boardId;
};
